<template>
  <div @click="goToHome()" class="home-btn text-center">
    <span>
      Back<br>
      <b-icon class="icon" icon="basket-fill" /><br/>
      Shopping
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    goToHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  .icon {
    font-size: 30px;
  }
  .home-btn {
    font-size: 14px;
    border-radius: 10px;
    position:fixed;
    right: 20px;
    bottom: 20px;
    padding: 5px;
    color: white;
    background: rgb(30,82,75);
    background: linear-gradient(180deg, rgba(30,82,75,1) 0%, rgba(41,105,98,1) 36%, rgba(48,122,115,1) 100%);
    transition: 200ms;
  }
  .home-btn:hover {
    background: rgb(30,82,75);
    background: linear-gradient(0deg, rgba(30,82,75,1) 0%, rgba(41,105,98,1) 36%, rgba(48,122,115,1) 100%);
    cursor: pointer;
    transform: scale(1.1);
    transition: 200ms;
  }
  .home-btn:active {
    background: rgb(30,82,75);
    background: linear-gradient(180deg, rgba(30,82,75,1) 0%, rgba(41,105,98,1) 36%, rgba(48,122,115,1) 100%);
    transition: 200ms;
    transform: scale(0.9);
  }
</style>
